import { ERROR_MESSAGES as CORE_ERROR_MESSAGES } from '@core/constants';

const ccName = import.meta.env.VITE_APP_CC_NAME;

export enum ERROR_MESSAGES_RESERVATION {
  UNOPENED = '오픈전입니다.',
  END = '마감되었습니다.',
  PAST = '마감되었습니다.',
  CLOSE = '휴장입니다.',
}

export enum BOARD_TYPE {
  NEWS = 'news',
  EVENT = 'event',
  JOIN = 'join',
  ARCHIVE = 'archive',
}

export const ERROR_MESSAGES: { [key: string]: string } = {
  ...CORE_ERROR_MESSAGES,
  INTERCEPTED_ID: `회원님은 홈페이지 사용이 제한된 상태입니다.<br />
홈페이지 사용을 원하시면<br /> ${ccName}로 연락주시기 바랍니다.<br />1899-1888`,
  FIND_ID_DUPLICATED_WEB_ID: `아이디가 2건 이상 조회되었습니다.<br />${ccName}로 연락주시기 바랍니다.<br />1899-1888`,
  NOT_EXIST_MEMBER: `입력하신 회원번호의 회원이 존재하지 않습니다.<br />${ccName}로 연락주시기 바랍니다.<br />1899-1888`,
  FIND_ID_DUPLICATED_MEMBER: `회원정보가 2건 이상 조회되었습니다.<br />${ccName}로 연락주시기 바랍니다.<br />1899-1888`,
  FIND_ID_DUPLICATED_MEMBERSHIP: `회원권정보가 2건 이상 조회되었습니다.<br />${ccName}로 연락주시기 바랍니다.<br />1899-1888`,
  NOT_FOUND_GROUP: '해당 일자에 패키지 예약이 마감되었습니다',
  NOT_ON_SALE: `판매기간이 아닙니다.`,
  NOT_FOUND_TICKET: `티켓정보가 존재하지 않습니다.`,
  PENALTY_PERIOD:
    '위약기간중입니다 <br/> :minPunishStartDate ~ :maxPunishEndDate 까지 <br/> 위약기간입니다',
  NOT_RESERVATION_COUNT_CHANGE: '예약 인원 수 변경 가능한 타임이 아닙니다.',
  NOT_EXIST_DPMNY: '예치금 정보가 없습니다.',
  CANNOT_RETURN_DPMNY:
    '이미 반환 신청된 내역이 존재하여 다시 신청하실 수 없습니다.',
  NOT_EXIST_DPMNY_INCOM: '입금 내역 정보가 없습니다.',
  NOT_EXIST_DPMNY_RETURN: '반환 가능한 예치금이 없습니다.',
  NOT_FOUND_ROOM_RESERVATION: '객실 예약 정보를 찾을 수 없습니다.',
  NOT_RESERVATION_CHANGE_DATE: '예약 변경 가능일자가 아닙니다.',
};

export enum ROUTE_NAME {
  Main = 'Main', // 메인
  PgPayment = 'PgPayment', //pg결제 화면 (리다이렉트 결제 관리)
  NotFound = 'NotFound', // 페이지없음
  RepairHomepage = 'RepairHomepage', // 시스템점검
  // auth
  Signin = 'Signin', // 로그인
  SigninAdmin = 'SigninAdmin', // 관리자로그인
  SignupAgree = 'SignupAgree', // 회원가입약관동의
  SignupCertification = 'SignupCertification', // 회원가입인증
  Signup = 'Signup', // 회원가입
  SignupComplete = 'SignupComplete', // 회원가입완료
  UserInfoModify = 'UserInfoModify', // 회원정보수정
  MyPage = 'MyPage', //마이페이지
  FindId = 'FindId', // ID 찾기
  FindPassword = 'FindPassword', // PW 찾기
  NewPasswordAccount = 'NewPasswordAccount', // 신규비밀번호생성
  MyInfoModify = 'MyInfoModify', // 회원정보 수정
  SignupIntro = 'SignupIntro', //회원가입종류 선택
  WebMembershipBenefit = 'WebMembershipBenefit', //웹회원혜택

  //agree
  ServiceTerms = 'ServiceTerms', // 이용약관
  InternetTerms = 'InternetTerms', // 인터넷이용약관
  PrivacyTerms = 'PrivacyTerms', // 개인정보 처리방침
  PrivacyEmail = 'PrivacyEmail', // 이메일 무단수집거부
  VideoInformation = 'VideoInformation', //영상정보처리기기 운영관리방침

  //클럽소개 club-info
  Intro = 'Intro', // 클럽개요
  ClubIntroduction = 'ClubIntroduction', // 클럽소개
  GolfTelIntro = 'GolfTelIntro', //골프텔 소개
  ResortIntro = 'ResortIntro', //리조트 소개

  ClubCi = 'ClubCi', // CI소개
  Greeting = 'Greeting', // 인사말
  ClubInformation = 'ClubInformation', // 클럽정보
  Location = 'Location', // 오시는길
  RealCam = 'RealCam', // 실시간현장

  //이용안내 use-information
  UseInformation = 'UseInformation', // 이용안내
  Guide = 'Guide', // 이용방법
  FeeInformation = 'FeeInformation', // 요금안내
  ReservInformation = 'ReservInformation', // 예약안내
  RuleInformation = 'RuleInformation', // 로컬룰
  AgreeTerms = 'AgreeTerms', // 약관동의

  //코스소개 club-introduction
  CourseInformation = 'CourseInformation', // 코스소개
  CourseIntroduction = 'CourseIntroduction', // 코스소개
  CourseStrategy = 'CourseStrategy', // 코스공략
  WestCourse = 'WestCourse',
  EastCourse = 'EastCourse',
  MiddleCourse = 'MiddleCourse',

  // 예약 reservation
  ReservationInformation = 'ReservationInformation', // 예약안내
  Reservation = 'Reservation', // 예약하기
  ReservationStatus = 'ReservationStatus', // 예약확인/취소
  ReservationPayment = 'ReservationPayment', // 예약결제
  ReservationModify = 'ReservationModify', // 예약변경
  ReservationFormModify = 'ReservationFormModify', // 예약수정

  // 부대시설 facility
  Facilities = 'Facilities', // 부대시설
  ClubHouse = 'ClubHouse', // 클럽하우스
  Restaurant = 'Restaurant', // 대식당
  LockerRoom = 'LockerRoom', // 로커룸
  StartHouse = 'StartHouse', // 스타트하우스
  Light = 'Light', // 라이트시설
  Lobby = 'Lobby', // 현관, 로비
  HalfwayHouse = 'HalfwayHouse', // 그늘집
  BanquetHall = 'BanquetHall', // 연회장
  GasStation = 'GasStation', // 주유소
  DrivingRange = 'DrivingRange', // 드라이빙레인지
  BBQ = 'BBQ', // 빌라가든 BBQ장
  GroupRoom = 'GroupRoom', // 단체실
  ProShop = 'ProShop', // 프로샵
  PuttingPractice = 'PuttingPractice', // 퍼팅연습

  // 커뮤니티 community
  Community = 'Community', // 커뮤니티
  EventWrite = 'EventWrite', // 이벤트 작성
  Notice = 'Notice', // 공지사항
  NoticeView = 'NoticeView', // 공지사항 상세
  NoticeWrite = 'NoticeWrite', // 공지사항 작성
  NoticeModify = 'NoticeModify', // 공지사항 작성
  Banner = 'Banner', // 배너
  BannerWrite = 'BannerWrite', // 배너 작성
  BannerModify = 'BannerModify', // 배너 수정
  Archive = 'Archive', // 자료실
  ArchiveView = 'ArchiveView', // 자료실 상세
  ArchiveWrite = 'ArchiveWrite', // 자료실 작성
  ArchiveModify = 'ArchiveModify', // 자료실 작성

  //고객의 소리 voc
  Withdrawal = 'Withdrawal', // 회원탈퇴

  // 기타
  CallbackNaver = 'CallbackNaver', // 네이버로그인콜백
  CallbackKakao = 'CallbackKakao', // 카카오로그인콜백
}
